import { useEffect, useState } from "react";
import HexLoader from "../../../../../../../components/HexLoader";
import DeliveryTimeline from "../DeliveryTimeline";
import { useSelector } from "react-redux";
import { getSupplierDetails } from "../../../../../../../redux/reducers/order/order-action";
import { formatDeliveryDurations } from "../delivery-types-utils";

const SelfPickupType = ({ selectedType, onBack, onSaveType }) => {
  const { carts } = useSelector((state) => state.order);
  const { supplier } = carts.cartProducts[0].product;

  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getSupplierDetails(supplier.id)
      .then(({ data }) => {
        setTimeline(data.timeline);
        setLoading(false);
      })
      .catch(console.error);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="delivery-types-timeline relative">
      <div className="delivery-date-container">
        {loading ? (
          <HexLoader />
        ) : (
          <DeliveryTimeline
            onBack={onBack}
            onSaveType={onSaveType}
            selectedType={selectedType}
            selectedTimeSlot={selectedType.timeSlot}
            timeSlots={formatDeliveryDurations({ timeline })}
          />
        )}
      </div>
    </div>
  );
};

export default SelfPickupType;
